import React from "react";

import ContentQuiz from "./ContentQuiz";

const Quiz = () => {
  return (
    <>
      <ContentQuiz />
    </>
  );
};

export default Quiz;
